<div class="fullcontainer" >
  <app-workshop-nav></app-workshop-nav>

  <div class='titleContainer mt-3'>
    <h2 class='header' style='color: #006498'>All Fitters</h2>
    <div>
    <button class='btn btn-secondary' routerLink='/4workshop/fitters/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    <button class='btn btn-secondary' routerLink='/4workshop/fitters/absence'><i class="fas fa-business-time"></i> Manage Absence</button>&nbsp;
    <button class='btn btn-secondary' routerLink='/4workshop/fitters/hours'><i class="fas fa-calendar"></i> Manage Hours</button>&nbsp;

    </div>
  </div>
  <br />
  <br />
  <app-grid
entity='fitter'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
